/**
 * Module: Heading with Paragraph
 *
 * Parent blocks:
 * - Carousel
 * - Grid
 */

/**
 * External dependencies
 */

/**
 * DWT dependencies
 */

/**
 * WP dependencies
 */

import {
  InspectorControls,
  __experimentalPanelColorGradientSettings as PanelColorGradientSettings,
  RichText,
  useBlockProps,
  BlockControls
} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarDropdownMenu, ToolbarButton } from '@wordpress/components';

import { __ } from '@wordpress/i18n';

/**
 * Parent blocks:
 * - Carousel
 * - Grid
 */

const Edit = ({ attributes, setAttributes }) => {
  const {
    heading,
    headingColor,
    text,
    textColor,
    headingLevel,
    linkTargetBlank
  } = attributes;

  const blockProps = useBlockProps({
    className: 'block__heading-with-paragraph'
  });

  /**
   * Heading/text settings
   */

  const onChangeHeading = ( newHeading ) => setAttributes({ heading: newHeading });
  const onChangeHeadingColor = ( newHeadingColor ) => setAttributes({ headingColor: newHeadingColor });
  const onChangeText = ( newText ) => setAttributes({ text: newText });
  const onChangeTextColor = ( newTextColor ) => setAttributes({ textColor: newTextColor });

  /**
   * Handle element styles
   */

  const hColor = headingColor ? { color: headingColor } : undefined;
  const tColor = textColor ? { color: textColor } : undefined;

  /**
   * Handle heading level
   */
  const headingLevels = [ 2, 3, 4 ];
  const handleHeadingLevel = ( newLevel ) => setAttributes({ headingLevel: newLevel });

  return (
    <>
      <BlockControls>
        <ToolbarGroup>
          <ToolbarDropdownMenu
            icon={<span className='font-bold text-[14px]'>H{headingLevel}</span>}
            label={ __( 'Select heading level', 'dwt-custom-theme' ) }
            controls={ headingLevels.map( ( level ) => ({
              title: `H${level} Heading`,
              isActive: headingLevel === level,
              onClick: () => handleHeadingLevel( level )
            }) ) }
            popoverProps={{ className: 'dwt-heading-dropdown-popover' }}
          />
          <ToolbarButton
            className={ linkTargetBlank ? 'is-pressed' : ''}
            icon='external'
            label='Open links in new tab'
            onClick={() => setAttributes({ linkTargetBlank: !linkTargetBlank })}
          />
        </ToolbarGroup>
      </BlockControls>
      <InspectorControls>
        <PanelColorGradientSettings
          title={ __( 'Color settings', 'dwt-custom-theme' ) }
          settings={ [
            {
              colorValue: headingColor,
              label: __( 'Heading', 'dwt-custom-theme' ),
              onColorChange: onChangeHeadingColor,
              clearable: true
            },
            {
              colorValue: textColor,
              label: __( 'Text', 'dwt-custom-theme' ),
              onColorChange: onChangeTextColor,
              clearable: true
            }
          ] }
        />
      </InspectorControls>

      <div { ...blockProps }>
        <div className='heading-with-paragraph--inner'>

          <RichText
            className={`heading-${headingLevel} heading-with-paragraph__heading`}
            tagName={`h${headingLevel}`}
            placeholder={ __( 'Enter headline text', 'dwt-custom-theme' ) }
            allowedFormats={ [ 'core/bold', 'core/italic' ] }
            value={ heading }
            onChange={ onChangeHeading }
            style={{ ...hColor }}
          />

          <RichText
            className='paragraph-1 heading-with-paragraph__text'
            tagName='p'
            placeholder={ __( 'Enter paragraph text', 'dwt-custom-theme' ) }
            value={ text }
            onChange={ onChangeText }
            style={{ ...tColor }}
          />

        </div>
      </div>
    </>
  );
};

export default Edit;
